import React, { useState } from "react";
import { api, formatErr } from "@/lib/api";
import { Search, PackageSearch, CheckCircle2, Clock } from "lucide-react";
import { CITIZEN } from "@/constants/testIds";

export default function TrackApplicationPage() {
  const [id, setId] = useState("");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setData(null); setLoading(true);
    try {
      const { data } = await api.get(`/applications/${id.trim()}`);
      setData(data);
    } catch (e) {
      setError(formatErr(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  const stages = ["submitted","under_review","site_visit","approved","subsidy_disbursed"];

  return (
    <div className="container-x py-12 max-w-2xl">
      <div className="label-tiny text-[hsl(var(--primary))]">Track</div>
      <h1 className="mt-1 text-3xl font-heading font-bold">Track your application</h1>
      <p className="mt-2 text-muted-foreground">Enter your Tracking ID (e.g., PEDA-APP-XXXXXXXX).</p>
      <form onSubmit={submit} className="mt-6 flex gap-2">
        <input data-testid={CITIZEN.trackInput} value={id} onChange={(e)=>setId(e.target.value)} className="input" placeholder="PEDA-APP-1A2B3C4D"/>
        <button data-testid={CITIZEN.trackBtn} className="btn-primary" disabled={loading}><Search className="h-4 w-4"/>{loading ? "Searching…" : "Track"}</button>
      </form>
      {error && <div className="mt-4 text-red-500 text-sm">{error}</div>}
      {data && (
        <div className="mt-8 rounded-2xl border border-border bg-card p-6">
          <div className="label-tiny text-muted-foreground">Tracking ID</div>
          <div className="font-mono font-semibold">{data.tracking_id}</div>
          <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
            <div><div className="text-muted-foreground text-xs">Scheme</div><div className="font-medium capitalize">{data.scheme.replace("_"," ")}</div></div>
            <div><div className="text-muted-foreground text-xs">District</div><div className="font-medium">{data.district}</div></div>
            <div><div className="text-muted-foreground text-xs">Applicant</div><div className="font-medium">{data.applicant_name}</div></div>
            <div><div className="text-muted-foreground text-xs">Status</div><div className="font-medium capitalize">{data.status.replace("_"," ")}</div></div>
          </div>
          <div className="mt-8">
            <div className="label-tiny mb-3">Progress</div>
            <div className="flex items-center gap-2">
              {stages.map((s, i) => {
                const done = stages.indexOf(data.status) >= i;
                return (
                  <React.Fragment key={s}>
                    <div className="flex flex-col items-center flex-1">
                      <div className={`h-8 w-8 rounded-full grid place-items-center ${done ? "bg-[hsl(var(--primary))] text-white" : "bg-muted text-muted-foreground"}`}>
                        {done ? <CheckCircle2 className="h-4 w-4"/> : <Clock className="h-4 w-4"/>}
                      </div>
                      <div className="mt-1 text-[10px] uppercase tracking-widest text-center max-w-[80px]">{s.replace("_"," ")}</div>
                    </div>
                    {i < stages.length-1 && <div className={`flex-1 h-0.5 ${done ? "bg-[hsl(var(--primary))]" : "bg-muted"}`}/>}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
